// extracted by mini-css-extract-plugin
module.exports = {"header":"EntryBrowserHome_header__3Ojzf"};